<template>
        <ul>
          <li class='notification-item' v-for="(notification, index) in allNotifications" :key="index" :class="{'unreaded-noti':!notification.status}">
            <div :id="notification.pk" @click="markNotificationRead(notification.pk)">
              <p class='noti-subject'>{{ notification.subject }}</p>
              <p class="noti-msg">{{ notification.customize_msg }}</p>
              <p class='noti-info'>
              <span>{{formateNotiDate(notification.trx_date)}} .</span>
              <i :class="{'pylon-icon-Electric':notification.mdm_utilities=='1','pylon-icon-Water':notification.mdm_utilities=='3','fas fa-burn':notification.mdm_utilities=='2'}"></i>
            {{notification.mdm_utilities=='1'?$t('electricity'):notification.mdm_utilities=='3'?$t('water'):$t('gas')}}: {{notification.meter_code}}</p>
             
            </div>
          </li>
          <li v-if="allNotifications.length==0">
            <div class="no-noti-found">
                <i class="pylon-icon-Notifications"></i>
                <span class="slash"></span>
                <p>{{$t('no_notification_found')}}</p>
            </div>
          </li>
        </ul>
</template>

<script>
import {mapGetters , mapActions} from 'vuex';
export default {
    name: 'NotificationList',
    props:['lang','company'],
    data(){
      return{
       now: new Date(),
      }
    },
     computed:{
        ...mapGetters(['allNotifications'])
    } ,
    methods: {
        ...mapActions(["markNotificationRead","getNotifications"]),

        formateNotiDate(date){
            // const now = new Date();
            let formatedDate=date.split(" ")[0].split('/').reverse().join('-');
            const current_date = new Date(formatedDate + ' ' +date.split(" ")[1]);
            const seconds = Math.floor((this.now - current_date) / 1000);

            const intervals = [
                { label: this.$t("year"), seconds: 31536000 },
                { label: this.$t("months"), seconds: 2592000 },
                { label: this.$t("day"), seconds: 86400 },
                { label: this.$t("hour"), seconds: 3600 },
                { label: this.$t("minute"), seconds: 60 },
            ];

            for (const interval of intervals) {
                const count = Math.floor(seconds / interval.seconds);
                    if (count >= 1) {
                        return `${count}${interval.label}`;
                    }
                }
            return this.$t("now");
        }
    },
    mounted() {
    setInterval(() => {
      this.now = new Date();
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
   
}
</script>

<style scoped>
ul{
list-style: none;
padding:0px;
}
.no-noti-found{
    padding: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px !important;
    font-size: 22px;
    font-weight: 700;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin: 16px;
}
.slash{
    position: absolute;
    display: inline-block;
    height: 25px;
    width: 2px;
    background: red;
    rotate: 45deg;
}
.notification-item{
    padding: 12px;
    background:#FAFAFA;
    border: 1px solid #E0E0E0E0;
    border-radius: 8px;
    margin-bottom: 12px;
    cursor: pointer;
    margin: 16px;
}
.noti-page .notification-item{
  margin: 16px 0px !important;
}
.notification-item.unreaded-noti {
    background: #E8EBF1 !important;
}

.notification-item div p{
  margin-bottom: 4px;
      font-size: 13px;
      font-weight: 500;
      color:#262338;
}
.notification-item div p.noti-subject{
  font-weight: 700;
}
.notification-item div p.noti-info{
  color: #767676;

}
</style>